/*!
 * Copyright (c) 2015-2017 Cisco Systems, Inc. See LICENSE file.
 */

import {Interceptor} from '@ciscospark/http-core';
import {SparkHttpError} from '@ciscospark/spark-core';
/**
 * Changes server url when it fails
 */
export default class ServerErrorInterceptor extends Interceptor {
  /**
  * @returns {HAMessagingInterceptor}
  */
  static create() {
    // eslint-disable-next-line no-invalid-this
    return new ServerErrorInterceptor({spark: this});
  }


  /**
   * @see Interceptor#onResponseError
   * @param {Object} options
   * @param {Object} reason
   * @returns {Object}
   */
  onResponseError(options, reason) {
    if ((reason instanceof SparkHttpError.InternalServerError) && options.uri) {
      const feature = this.spark.internal.device.features.developer.get('web-high-availability');

      if (feature && feature.value) {
        this.spark.internal.metrics.submitClientMetrics('web-ha', {
          fields: {success: false},
          tags: {action: 'failed', error: reason.message, url: options.uri}
        });

        return this.spark.internal.device.markUrlFailedAndGetNew(options.uri)
          .then(() => Promise.reject(reason));
      }
    }

    return Promise.reject(reason);
  }
}
